import { useState } from 'react';
import useEffectOnce from '@main-hooks/useEffectOnce';
import { useTranslation } from 'react-i18next';
import { Currency } from '@configs/language';
import { COUNTRY_FLAG_ICON } from '@configs/language/config';
import useCombineBalances from '@main-hooks/useCombinedBalances';
import constants from '../constants';
import {
  UseCreateNewAccountProps,
  UseCreateNewAccountReturn,
} from '../types/UseCreateNewAccount.types';

const useCreateNewAccount = ({
  onChangeSelectedCurrency,
}: UseCreateNewAccountProps): UseCreateNewAccountReturn => {
  const { t } = useTranslation();

  const { dataMixed } = useCombineBalances();

  const [currencyFlag, setCurrencyFlag] = useState<JSX.Element>(
    COUNTRY_FLAG_ICON[constants.AVAILABLE_OPTIONS[0] as Currency] as JSX.Element
  );

  const options = constants.AVAILABLE_OPTIONS.filter((option) => {
    const walletAleadyExist = dataMixed.walletsDataMixed?.find(
      (item) => item.currency.name === option
    );

    return !walletAleadyExist;
  }).map((option) => {
    const [currency, ...currencyName] = t(`w${option}`).split(' ');

    return {
      currency,
      currencyName: currencyName.join(' '),
    };
  });

  const handleChange = (currency: string) => {
    const currencyData = options.find((item) => item.currency === currency);
    if (!currencyData) return;

    onChangeSelectedCurrency(currencyData);
    setCurrencyFlag(COUNTRY_FLAG_ICON[currency as Currency] as JSX.Element);
  };

  useEffectOnce(() => {
    handleChange(options[0].currency);
  });

  return {
    currencyFlag,
    options,
    handleChange,
  };
};

export default useCreateNewAccount;
